export default __webpack_public_path__ + "static/media/growth-notes-logo3x.497f4aab.png";